<template>
  <header class="gig-header fixed w-full backdrop-blur-sm z-50 shadow-sm">
    <div class="container mx-auto px-4 py-4 flex justify-between items-center">
      <div class="flex items-center">
        <NuxtImg
          src="/img/logo/gig-logo.png"
          width="210"
          height="50"
          class="max-w-[150px] md:max-w-fit"
        />

        <!-- <Icon
          name="fluent:phone-32-light"
          size="40"
          class="mr-2"
          style="color: #818cf8"
        />
        <span class="text-2xl font-bold gig-landing-text-purple"> Gigcep </span> -->
      </div>

      <nav class="hidden md:flex flex-row gap-4">
        <a
          href="#home"
          class="text-gray-700 gig-hover-purple transition-colors"
        >
          Ana Sayfa
        </a>
        <a
          href="#how-it-works"
          class="text-gray-700 gig-hover-purple transition-colors"
        >
          Nasıl Çalışır
        </a>
        <a
          href="#contact"
          class="text-gray-700 gig-hover-purple transition-colors"
        >
          İletişim
        </a>

        <a
          href="#contact"
          class="text-gray-700 gig-hover-purple transition-colors"
          @click="openMobilAppUrl"
        >
          İndir
        </a>

        <NuxtLink
          to="https://m.gigcep.com/"
          class="text-gray-700 gig-hover-purple transition-colors"
        >
          Giriş Yap / Kayıt Ol
        </NuxtLink>
      </nav>

      <button
        class="md:hidden text-gray-700 focus:outline-none"
        @click="toggleMobileMenu"
      >
        <template v-if="mobileMenuOpen">
          <Icon name="meteor-icons:xmark" class="size-6" />
        </template>
        <template v-else>
          <Icon name="material-symbols:menu-rounded" class="size-6" />
        </template>
      </button>
    </div>

    <nav
      class="gig-mobile-nav bg-white shadow-inner relative transition-height duration-300 ease-in-out md:hidden"
      :class="{
        'max-h-0 overflow-hidden': !mobileMenuOpen,
        open: mobileMenuOpen,
      }"
    >
      <div class="flex flex-col space-y-4 py-4 px-4">
        <a
          href="#home"
          class="text-gray-700 gig-hover-purple transition-colors"
          @click="toggleMobileMenu"
        >
          Ana Sayfa
        </a>
        <a
          href="#how-it-works"
          class="text-gray-700 gig-hover-purple transition-colors"
          @click="toggleMobileMenu"
        >
          Nasıl Çalışır
        </a>
        <a
          href="#contact"
          class="text-gray-700 gig-hover-purple transition-colors"
          @click="toggleMobileMenu"
        >
          İletişim
        </a>
        <NuxtLink
          to="/login"
          class="text-gray-700 gig-hover-purple transition-colors"
        >
          Giriş Yap / Kayıt Ol
        </NuxtLink>
      </div>
    </nav>
  </header>
</template>

<script lang="ts" setup>
const mobileMenuOpen = ref(false)

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

function openMobilAppUrl() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.gigcep.app",
    "_blank",
  )
}
</script>

<style scoped>
.gig-header {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
}
.gig-mobile-nav {
  transition: max-height 0.3s ease-in-out !important;
  max-height: 0;
  overflow: hidden;
}
.gig-mobile-nav.open {
  max-height: 400px;
}
</style>
